import Enquire from "./Enquire";

export default Enquire;
